"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9572,7273],{

/***/ 71357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "Ui": function() { return /* binding */ mediaQueryHOC; },
/* harmony export */   "ag": function() { return /* binding */ useMatchMedia; },
/* harmony export */   "hZ": function() { return /* binding */ useScrollBlock; },
/* harmony export */   "y3": function() { return /* binding */ updateCurrentProductIndex; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91058);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // https://github.com/streamich/react-use/blob/master/docs/useIsomorphicLayoutEffect.md


var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_13__.useLayoutEffect : 0;
function useMatchMedia(mediaQueryString) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(initialValue),
      match = _useState[0],
      setMatch = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    if (!window.matchMedia) {
      return;
    }

    function handleMatch(event) {
      setMatch(event.matches);
    }

    var matchMedia = window.matchMedia(mediaQueryString);
    setMatch(matchMedia.matches);
    matchMedia.addListener(handleMatch);
    return function () {
      matchMedia.removeListener(handleMatch);
    };
  }, [mediaQueryString]);
  return match;
}
var mediaQueryHOC = function mediaQueryHOC(Component) {
  function MediaQueryHOC(props) {
    var isXSmall = useMatchMedia('(max-width: 375px)');
    var isSmall = useMatchMedia('(max-width: 479px)');
    var isMedium = useMatchMedia('(max-width: 767px)');
    var isLarge = useMatchMedia('(max-width: 991px)');
    var isXLarge = useMatchMedia('(max-width: 1023px)');
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(Component, _objectSpread({
      isXSmall: isXSmall,
      isSmall: isSmall,
      isMedium: isMedium,
      isLarge: isLarge,
      isXLarge: isXLarge
    }, props));
  }

  return MediaQueryHOC;
};
var listeners = [];
var state = {
  currentProductIndex: 0
};

var setState = function setState(newState) {
  state = _objectSpread(_objectSpread({}, state), newState);
  listeners.forEach(function (listener) {
    listener(state);
  });
};

var updateCurrentProductIndex = function updateCurrentProductIndex() {
  var newListener = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)()[1];
  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    listeners.push(newListener);
  }, []);
  return [state, setState];
};
var useScrollBlock = function useScrollBlock() {
  var scroll = (0,react__WEBPACK_IMPORTED_MODULE_13__.useRef)(false);

  var blockScroll = function blockScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document = document,
        body = _document.body;
    if (!(body == null ? void 0 : body.style) || scroll.current) return;
    var scrollBarWidth = window.innerWidth - html.clientWidth;
    var bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue("padding-right")) || 0;
    Object.assign(html.style, {
      position: "relative",
      overflow: "hidden"
    });
    Object.assign(body.style, {
      position: "relative",
      overflow: "hidden",
      paddingRight: "".concat(bodyPaddingRight + scrollBarWidth, "px")
    });
    scroll.current = true;
  };

  var allowScroll = function allowScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document2 = document,
        body = _document2.body;
    if (!(body == null ? void 0 : body.style) || !scroll.current) return;
    Object.assign(html.style, {
      position: "",
      overflow: ""
    });
    Object.assign(body.style, {
      position: "",
      overflow: "",
      paddingRight: ""
    });
    scroll.current = false;
  };

  return [blockScroll, allowScroll];
};

/***/ }),

/***/ 7273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1216);
/* harmony import */ var react_scroll_parallax__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77776);
/* harmony import */ var react_scroll_parallax_cjs_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9476);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23493);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _adapters_cloudinary_ImageFactory__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42456);
/* harmony import */ var _adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71357);
/* harmony import */ var _BackgroundImage_BackgroundImage_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53633);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8996);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24036);
/* harmony import */ var _adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);















function Img(props) {
  var imageId = props.imageId,
      contentImageId = props.contentImageId,
      elemId = props.elemId,
      alt = props.alt,
      transformations = props.transformations,
      customClassName = props.customClassName,
      alignmentClassName = props.alignmentClassName,
      format = props.format,
      noLazyLoad = props.noLazyLoad,
      resetImage = props.resetImage,
      ariaHidden = props.ariaHidden;
  var nodeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var nodeImg = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      width = _useState[0],
      setWidth = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .ImageConstants.defaultWidth */ .j6.defaultWidth),
      windowWidth = _useState2[0],
      setWindowWidth = _useState2[1];

  var isPreload = props.isPreload;
  var isBannerImage = props.isBannerImage;
  var classname = 'ob-mainAsset-wrapper';
  if (alignmentClassName) classname += " ".concat(alignmentClassName);
  if (customClassName) classname += " ".concat(customClassName);

  function updateWidth() {
    if (nodeRef.current) {
      setWidth((0,_BackgroundImage_BackgroundImage_helpers__WEBPACK_IMPORTED_MODULE_9__/* .roundUpTheSize */ .V)(nodeRef.current.getBoundingClientRect().width));
    }
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var handleResize = lodash_throttle__WEBPACK_IMPORTED_MODULE_5___default()(updateWidth, 100);
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
      handleResize.cancel();
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    window.addEventListener('resize', windowResize);
    windowResize();
    return function () {
      window.removeEventListener('resize', windowResize);
    };
  }, []);

  function windowResize() {
    setWindowWidth(window.innerWidth);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (resetImage && nodeImg.current) {
      var imgSrc = nodeImg.current.src;
      nodeImg.current.src = '';
      setTimeout(function () {
        nodeImg.current.src = imgSrc;
      }, 0);
    }
  }, [resetImage]);
  (0,_adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_8__/* .useIsomorphicLayoutEffect */ .LI)(updateWidth, []);
  var finalTransformations = "w_".concat(width !== 0 ? width : 'auto').concat(transformations ? ',' + transformations : '', ",q_auto,f_").concat(format);

  if (isPreload) {
    finalTransformations = "w_".concat(windowWidth < _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .ImageConstants.defaultDesktopWidth */ .j6.defaultDesktopWidth ? _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .ImageConstants.defaultWidth */ .j6.defaultWidth : width !== 0 ? width : 'auto').concat(transformations ? ',' + transformations : '', ",q_auto,f_").concat(format);
  }

  var preloadImageUrl = contentImageId && (0,_adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_12__/* .optimizeImage */ .H)(_adapters_cloudinary_ImageFactory__WEBPACK_IMPORTED_MODULE_7__/* ["default"].buildContentfullImageUrl */ .ZP.buildContentfullImageUrl(contentImageId));
  var url = contentImageId && (0,_adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_12__/* .optimizeImage */ .H)(_adapters_cloudinary_ImageFactory__WEBPACK_IMPORTED_MODULE_7__/* ["default"].buildContentfullImageUrlByWidth */ .ZP.buildContentfullImageUrlByWidth(contentImageId, width)); // We can't call dpr 1.5/2/3 and add srcset because we don't know if the image really exist.
  // If you call an image of width 500px then this image does not exist cloudinary will provide an auto width image
  // The problem: In this case the 2x image will display a width auto image divided by 2, if 3x it will divided the image by 3.
  // We can't force the user to upload 3x 2x images.
  //const srcSet = (width !== 0) ? ImageFactory.dpr(image, finalTransformations) : undefined;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
    className: "".concat(classname ? classname : '', " ").concat(props.imageClassName ? props.imageClassName : ''),
    ref: nodeRef,
    style: {
      marginBottom: props.offsetBottom,
      marginTop: props.offsetTop,
      marginLeft: props.offsetLeft,
      marginRight: props.offsetRight,
      transform: props.scale ? "scale(".concat(props.scale, ")") : undefined
    },
    children: [isPreload && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("link", {
        rel: "preload",
        href: preloadImageUrl,
        as: "image"
      })
    }), !noLazyLoad && !isPreload ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_2__["default"], {
      offset: 500,
      children: props.hasAssetParallax && !(0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_10__/* .isIE */ .w1)() ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(ParallaxImg, {
        imgRef: nodeImg,
        imgClassName: "ob-mainAsset-wrapper-img",
        id: elemId,
        src: url,
        alt: alt,
        x: props.assetX,
        ariaHidden: ariaHidden,
        y: props.assetY
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("img", {
        ref: nodeImg,
        className: "ob-mainAsset-wrapper-img",
        id: elemId,
        src: url,
        "aria-hidden": ariaHidden,
        alt: alt || '',
        "aria-label": "banner-image"
      })
    }) : props.hasAssetParallax && !(0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_10__/* .isIE */ .w1)() ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(ParallaxImg, {
      imgRef: nodeImg,
      id: elemId,
      src: url,
      alt: alt,
      ariaHidden: ariaHidden,
      x: props.assetX,
      y: props.assetY
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("img", {
      ref: nodeImg,
      className: isPreload && isBannerImage && 'ob-background-wrapper-visible',
      id: elemId,
      src: preloadImageUrl,
      "aria-hidden": ariaHidden,
      alt: alt || ''
    })]
  });
}
Img.defaultProps = {
  transformations: 'c_limit',
  format: 'auto',
  hasAssetParallax: false,
  resetImage: false
};

function ParallaxImg(_ref) {
  var imgRef = _ref.imgRef,
      x = _ref.x,
      y = _ref.y,
      src = _ref.src,
      alt = _ref.alt,
      imgClassName = _ref.imgClassName,
      id = _ref.id,
      ariaHidden = _ref.ariaHidden;
  var parallaxController = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(react_scroll_parallax_cjs_helpers__WEBPACK_IMPORTED_MODULE_4__.ParallaxContext);
  var handleLoad = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    // updates cached values after image dimensions have loaded
    parallaxController.update();
  }, [parallaxController]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_scroll_parallax__WEBPACK_IMPORTED_MODULE_3__/* .Parallax */ .VS, {
    className: "img-parallax",
    x: x,
    y: y,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("img", {
      ref: imgRef,
      className: imgClassName,
      id: id,
      "aria-hidden": ariaHidden,
      src: src,
      alt: alt || '',
      onLoad: handleLoad
    })
  });
}

/***/ })

}]);